import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Professional Software Developers in San Francisco</h2>
            </div>
            <p>
              Embracing change and investing in digital transformation has
              turned startups into multi-million dollar businesses. As one of
              the leading software developers in San Francisco, TekRevol can
              help you embrace change and scale exponentially with
              technology-driven, user-centric, and state-of-the-art software
              solutions.
            </p>
            <p>
              Our comprehensive software development competencies enable us to
              provide our clients with cutting-edge software solutions and
              empower them to maximize their productivity. We are devoted to
              enabling startups and enterprises to embrace digital
              transformation to build a sustainable, scalable, and socially
              responsible society.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
